// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';
import {
  SimpleNotificationOptions,
  SimpleNotificationService,
} from './simple-notification.service';

@Injectable()
export class ClipboardService {
  constructor(private simpleNotificationService: SimpleNotificationService) {}

  copyToClipboard(
    data: string,
    notification: SimpleNotificationOptions | undefined = {
      text: 'Copied to clipboard',
      icon: 'copy-results-to-clipboard',
    }
  ): void {
    const error = () =>
      this.simpleNotificationService.notify({
        text: 'Error copying to clipboard',
        icon: 'copy-results-to-clipboard',
      });
    navigator.clipboard
      .writeText(data)
      .then(() => {
        if (notification) {
          this.simpleNotificationService.notify(notification);
        }
      })
      .catch(() => {
        error();
      });
  }
}
